import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import Tabs from '../../components/shared/Tabs';
import './page-projects-start.css';
import { btSort } from '../../utils/bt-array';
import BtButton from '../bt-button/bt-button';
import { TrashIcon } from '../../components/svgs';
import { ReactComponent as EditIcon } from '../../assets/svg/editIcon.svg';
import appState from '../../state/AppStateContainer';
import appEnum, { SavingState } from '../../util/appEnum';
import TableSelector from '../../components/shared/TableSelector/TableSelector';
import services from '../../services';
import FiltersDropdown from '../../components/shared/FiltersDropdown/FiltersDropdown';
import { isEmpty } from 'lodash';
import { ServiceProjects } from '../../services/service-projects';
import { ServiceUser } from '../../services/service-user';
import SearchBarWithActions from '../../components/shared/SearchBarWithActions/SearchBarWithActions';
import OptionsMenu from '../../components/shared/OptionsMenu/OptionsMenu';
import TooltipContainer from '../../components/shared/TooltipContainer/TooltipContainer';
import Legends from '../../components/shared/Legends/Legends';
import { NotificationManager } from 'react-notifications';
import { ReactComponent as PresentationIcon } from '../../assets/svg/presentationIcon.svg';
import PaginationWithGoTo from '../pagination-with-goto/pagination-with-goto';
import { ReactComponent as StationIcon } from '../../assets/svg/stationIcon.svg';
import { ReactComponent as HealthBuildingIcon } from '../../assets/svg/healthBuildingIcon.svg';
import { ReactComponent as HouseIcon } from '../../assets/svg/houseIcon.svg';
import { ReactComponent as HotelIcon } from '../../assets/svg/hotelIcon.svg';
import { ReactComponent as PowerIcon } from '../../assets/svg/powerIcon.svg';
import { ReactComponent as FactoryIcon } from '../../assets/svg/factoryIcon.svg';
import { ReactComponent as BuildingIcon } from '../../assets/svg/buildingIcon.svg';
import { ReactComponent as RoadIcon } from '../../assets/svg/roadIcon.svg';
import { ReactComponent as PingPongIcon } from '../../assets/svg/pingPongIcon.svg';
import { ReactComponent as MeetingIcon } from '../../assets/svg/meetingIcon.svg';
import { ReactComponent as FootballFieldIcon } from '../../assets/svg/footballFieldIcon.svg';
import { ReactComponent as ShopIcon } from '../../assets/svg/shopIcon.svg';
import { ReactComponent as TunnelIcon } from '../../assets/svg/tunnelIcon.svg';
import { ReactComponent as SchoolBagIcon } from '../../assets/svg/schoolBagIcon.svg';
import { ReactComponent as EmailCheckIcon } from '../../assets/svg/emailCheckIcon.svg';
import AppLayout from '../../components/layout/app-layout/app-layout';
import DataTable from '../../components/shared/DataTable/DataTable';
import CustomizationMenu from '../../components/shared/CustomizationMenu/CustomizationMenu';
import NotificationCounter from '../../components/shared/NotificationCounter/NotificationCounter';
import { useTranslation } from 'react-i18next';
import { CustomAvatar } from '../../components/shared';
import Modal from '../../components/shared/Modal/Modal';
import AppCreateProject from '../app-create-project/app-create-project';
import TeamBuilder from '../../components/shared/TeamBuilder/TeamBuilder';

const MAX_CLOSED_PROJECTS = 10;

const projectTypeToIconMap = (props) => ({
  'Kontorsbyggnader': <PresentationIcon {...props} />,
  'Samfärdsel': <StationIcon {...props} />,
  'Sjuk & Hälsovård': <HealthBuildingIcon {...props} />,
  'Gruppbyggda småhus': <HouseIcon {...props} />,
  'Hotell / Restaurang': <HotelIcon {...props} />,
  'Kraft & Belysning': <PowerIcon {...props} />,
  'Industrier / Verkstad / Lager': <FactoryIcon {...props} />,
  'Flerbostadshus': <BuildingIcon {...props} />,
  'Vägar / Gator / Broar / Vatten': <RoadIcon {...props} />,
  'Idrott / Fritidsanläggning': <PingPongIcon {...props} />,
  'Samlingslokaler': <MeetingIcon {...props} />,
  'Idrott Utomhus': <FootballFieldIcon {...props} />,
  'Affärslokaler': <ShopIcon {...props} />,
  'Tunnel': <TunnelIcon {...props} />,
  'Skola / Förskola': <SchoolBagIcon {...props} />,
});

const importAll = (r) => {
  let images = {};
  r.keys().forEach(item => { images[item.replace('./', '')] = r(item); });
  return images
};

const images = importAll(require.context('../../assets/images/KommunIcons', false, /\.(png|jpe?g|svg)$/));

export const consolidateColumnConfiguration = (projectListConfig, defaultColumnConfiguration, saveColumnConfig) => {
  const columnNamesInConfig = projectListConfig.map(x => x.name);
  const defaultColumnNames = defaultColumnConfiguration.map(x => x.name);
  const newColumns = defaultColumnConfiguration.filter(x => !columnNamesInConfig.includes(x.name));
  const updatedColumns = projectListConfig.filter(x => defaultColumnNames.includes(x.name)); // remove columns which don't exist in default column configuration

  if (newColumns.length || updatedColumns.length !== projectListConfig.length) {
    // Insert each new column after the column it appears after in the default column configuration
    newColumns.forEach((column) => {
      let prevIndex = defaultColumnNames.indexOf(column.name) - 1;
      let insertIndex;
      if (prevIndex >= 0) {
        let prevName = defaultColumnNames[prevIndex];
        insertIndex = updatedColumns.findIndex(c => c.name === prevName) + 1;
      } else {
        insertIndex = 0;
      }
      updatedColumns.splice(insertIndex, 0, column);
    });
    saveColumnConfig(updatedColumns);
  }

  return updatedColumns;
};

export default function PageProjectsStart({ addProject, removeProject, history, clearNotifications, clearAllNotifications }) {
  const [t] = useTranslation('projects');
  const [tPagination] = useTranslation('pagination', { keyPrefix: 'pagination' });
  const getPageLimit = (selectedTab, numberOfProjects) => {
    return selectedTab ? MAX_CLOSED_PROJECTS : numberOfProjects || 1;
  };
  const [projects, setProjects] = useState([]);
  const [selectedProjectTab, setSelectedProjectTab] = useState(0);
  const [openProjects, setOpenProjects] = useState([]);
  const [closedProjects, setClosedProjects] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const tableRef = useRef(null);
  const [cities, setCities] = useState([]);
  const [projectTypes, setProjectTypes] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(
    getPageLimit(selectedProjectTab, selectedProjects.length),
  );
  const [isLoading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [totalAreas, setTotalAreas] = useState(0);
  const [filtersData, setFiltersData] = useState({
    projectType: [],
    kommun: [],
    phase: [],
    users: [],
  });
  const [showFilter, toggleFilter] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [projectToEdit, setProjectToEdit] = useState(null);
  const [users, setUsers] = useState([]);
  const appCreateProjectRef = useRef(null);

  const refreshProjectList = async () => {
    setLoading(true);
    try {
      const updatedProjects = await ServiceProjects.getProjectList();
      setProjects(updatedProjects);
    } catch (error) {
      console.error('Failed to refresh project list:', error);
    } finally {
      setLoading(false);
    }
  };

  const getFilteredResult = (projectsToFilter) => {
    const filteredResult = projectsToFilter
      .filter(project => project.name.toUpperCase().includes(searchValue.toUpperCase()))
      .filter(project => (!isEmpty(filtersData.kommun) ? filtersData.kommun.includes(project.province) : true))
      .filter(project => (!isEmpty(filtersData.projectType) ? filtersData.projectType.includes(project.projectTypeName) : true))
      .filter(project => {
        if (!filtersData.phase?.length) return true;
        if (filtersData.phase?.includes('') && !project.phase) return true;
        return filtersData.phase.includes(project.phase);
      })
      .filter(project => {
        if (!isEmpty(filtersData.users)) {
          const projectResponsibleId = project.responsible?._id;

          const projectMemberIds = project.members || [];

          const hasMatchingUser = filtersData.users.some(userId =>
            userId === projectResponsibleId ||
            projectMemberIds.includes(userId)
          );

          return hasMatchingUser;
        }
        return true;
      });


    setTotalAreas(filteredResult.reduce(
      (prev, curr) => Math.max(prev, curr.stepOneAreas + curr.stepTwoAreas + curr.stepThreeAreas + curr.stepFourAreas),
      0
    ));
    return filteredResult;
  };

  const sortProjects = (open) => btSort(
    projects.filter(p => p.isOpen == open),
    'createdAt',
    'desc',
  );

  const COLUMN_NAMES = {
    project: t('table.header.project', 'Projekt'),
    responsible: t('table.header.responsible', 'Ansvarig'),
    phase: t('table.header.phase', 'Skede'),
    projectNo: t('table.header.projectNo', 'Projektnummer'),
    projectType: t('table.header.projectType', 'Projekttyp'),
    region: t('table.header.region', 'Kommun'),
    requests: t('table.header.requests', 'Upphandlingar'),
    status: t('table.header.status', 'Status'),
    estCost: t('table.header.estCost', 'Estimerad projektkostnad'),
    users: t('table.header.users', 'Användare'),
    members: t('table.header.members', 'Medarbetare')
  };

  const DEFAULT_COLUMN_CONFIGURATION = [
    {
      name: 'Projekt',
      displayName: COLUMN_NAMES.project,
      show: true,
      static: true,
    }, {
      name: 'Responsible',
      displayName: COLUMN_NAMES.responsible,
      show: true,
    },
    {
      name: 'Members',
      displayName: COLUMN_NAMES.members,
      show: true,
    },
    {
      name: 'Skede',
      displayName: COLUMN_NAMES.phase,
      show: true,
    }, {
      name: 'Projektnummer',
      displayName: COLUMN_NAMES.projectNo,
      show: true,
    }, {
      name: 'Projekttyp',
      displayName: COLUMN_NAMES.projectType,
      show: false,
    }, {
      name: 'Kommun',
      displayName: COLUMN_NAMES.region,
      show: true,
    }, {
      name: 'Upphandlingar',
      displayName: COLUMN_NAMES.requests,
      show: true,
    }, {
      name: 'Status',
      displayName: COLUMN_NAMES.status,
      show: true,
    }, {
      name: 'Estimerad projektkostnad',
      displayName: COLUMN_NAMES.estCost,
      show: true,
    }
  ];

  const saveTableColumns = async (data) => {
    await ServiceUser.updatePreferences(appState.getUserId(), data, appEnum.userPrefrences.projectTable);
  }
  const updateColumns = async (data) => {
    await saveTableColumns(data);
    setColumns(data);
  }
  const setupTableConfiguration = async () => {
    await appState.getUserDetails();
    const projectListConfig = appState.getProjectListPreferences();
    setColumns(projectListConfig ? consolidateColumnConfiguration(projectListConfig, DEFAULT_COLUMN_CONFIGURATION, saveTableColumns) : DEFAULT_COLUMN_CONFIGURATION);
  }

  useEffect(() => {
    columns.forEach((column) => {
      column.displayName = DEFAULT_COLUMN_CONFIGURATION.find(x => x.name === column.name)?.displayName;
    });
  }, [DEFAULT_COLUMN_CONFIGURATION]);

  useEffect(() => {
    setLoading(true);
    (async function () {
      setCities((await services.getCities()).map(city => ({ label: city, value: city })));

      setProjectTypes((await ServiceProjects.getProjectTypes()).map(pT => ({ label: pT.name, value: pT._id })));

      setProjects(await ServiceProjects.getProjectList());

      await setupTableConfiguration();
      const filtersPreferences = appState.getProjectFilterPreferences();
      setFiltersData((prev) => ({
        ...prev,
        ...filtersPreferences
      }));
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    const oProjects = sortProjects(true);
    const cProjects = sortProjects(false);
    setOpenProjects(oProjects);
    setClosedProjects(cProjects);
    setSelectedProjects(getFilteredResult(selectedProjectTab ? cProjects : oProjects));
  }, [projects]);

  useEffect(() => {
    setSelectedProjects(getFilteredResult(selectedProjectTab ? closedProjects : openProjects));
  }, [currentPage, selectedProjectTab, searchValue, filtersData]);

  useEffect(() => {
    setPageLimit(() => {
      const pageLimit = getPageLimit(selectedProjectTab, selectedProjects.length);
      tableRef.current.dataManager.changePageSize(pageLimit);
      return pageLimit;
    });
  }, [selectedProjects]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedProjectTab]);

  useEffect(() => {
    const fetchUsers = async () => {
      const users = await ServiceUser.getTasksUsers();
      setUsers(users.map(user => ({ label: user.name, value: user._id, projects: user.projects, role: user.role, avatarUrl: user.avatarUrl })));
    };
    fetchUsers();
  }, []);

  const isWriteAccessRole = appState.isWriteAccessRole();

  const getNotificationCount = projectNotifications => {
    if (projectNotifications && projectNotifications > 0) {
      return projectNotifications;
    }
    return 0;
  };

  const getColumns = () => {
    const getProjectTypeComponent = (rowData) => (
      <TooltipContainer renderReferenceComponent={(className, ref) =>
        <div ref={ref} className={`projectTypeContainer ${className}`} style={{ visibility: rowData.projectTypeName ? 'visible' : 'hidden' }}>
          {projectTypeToIconMap({ width: 18, height: 18 })[rowData.projectTypeName]}
        </div>
      }>
        {rowData.projectTypeName && t(`projectType.${rowData.projectTypeName.replace(/[\s&/]/g, '')}`, rowData.projectTypeName)}
      </TooltipContainer>
    )

    return [...columns.filter(column => column.show || column.static).map(column => {
      switch (column.name) {
        case 'Projekt':
          return {
            title: COLUMN_NAMES.project,
            field: 'name',
            render: (rowData) => (
              <div className="projectColumn" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div>{getProjectTypeComponent(rowData)}</div>
                  <span style={{ color: 'var(--gray-900)', fontSize: '16px' }}>{rowData.name}</span>
                </div>
                <div><NotificationCounter counter={getNotificationCount(rowData.notification)} /></div>
              </div>
            ),
            cellStyle: {
              width: '400px'
            },
            customSort: (a, b) => {
              const aName = a?.name ?? '';
              const bName = b?.name ?? '';
              return aName.localeCompare(bName, undefined, { numeric: true });
            },
          };
        case 'Responsible':
          return {
            title: COLUMN_NAMES.responsible,
            render: rowData => {
              const responsible = rowData?.responsible;
              return (
                <div>
                  {responsible && (
                    <div className="responsible" key={responsible._id}>
                      <CustomAvatar src={responsible.avatarUrl || undefined} alt={responsible.name} size="30px" />
                      <div>{responsible.name}</div>
                    </div>
                  )}
                </div>
              );
            },
            customSort: (a, b) => {
              const aName = a?.responsible?.name ?? '';
              const bName = b?.responsible?.name ?? '';
              return bName.localeCompare(aName, undefined, { numeric: true });
            },
            cellStyle: { width: '200px' },
            align: 'left'
          };
        case 'Members':
          return {
            title: COLUMN_NAMES.members,
            render: rowData => {
              const memberIds = rowData?.members || [];
              const projectMembers = users.filter(user => memberIds.includes(user.value))
                .map(user => ({
                  _id: user.value,
                  name: user.label,
                  avatarUrl: user.avatarUrl
                }));

              if (projectMembers.length > 5) {
                return (
                  <TooltipContainer renderReferenceComponent={(className, ref) =>
                    <span className={className} ref={ref}>
                      {projectMembers.length} {COLUMN_NAMES.members.toLowerCase()}
                    </span>}
                  >
                    <ul style={{
                      listStyleType: 'none',
                      padding: '16px 24px 0 24px', margin: '-20px -20px 0 -20px',
                      fontSize: '14px', color: 'var(--gray-700)',
                      display: 'flex', flexDirection: 'column', gap: '4px',
                      maxHeight: '320px', overflow: 'auto'
                    }}>
                      {projectMembers.sort((a, b) => a.name.localeCompare(b.name)).map(user => <li key={user._id} style={{ display: 'flex', gap: '8px', alignItems: 'center' }}><CustomAvatar alt={user.name} src={user.avatarUrl} size="30px" /> {user.name}</li>)}
                    </ul>
                  </TooltipContainer>
                );
              }
              return (
                <div style={{ pointerEvents: 'none' }} onClick={(e) => e.stopPropagation()}>
                  <TeamBuilder
                    readOnly
                    users={users}
                    areaUsers={projectMembers}
                    currentProject={rowData}
                    areaId="project-members"
                    avatarSize="30px"
                    setAreaUsers={(updatedMembers) => {
                      setProjects(oldProjects =>
                        oldProjects.map(project =>
                          project._id === rowData._id
                            ? { ...project, members: updatedMembers.map(member => member._id) }
                            : project
                        )
                      );
                    }}
                  />
                </div>
              );
            },
            customSort: (a, b) => {
              const aMembersCount = a?.members?.length ?? 0;
              const bMembersCount = b?.members?.length ?? 0;
              return bMembersCount - aMembersCount;
            },
            // cellStyle: { width: '200px' },
            align: 'left'
          };
        case 'Skede':
          return {
            title: COLUMN_NAMES.phase,
            render: rowData => {
              const [currentPhase, setCurrentPhase] = useState(rowData?.phase || '');

              const options = [
                { label: t('projectPhase.AnbudKalkyl', 'Anbud/Kalkyl'), value: 'Anbud/Kalkyl' },
                { label: t('projectPhase.InköpProduktion', 'Inköp/Produktion'), value: 'Inköp/Produktion' }
              ];

              const selectedPhase = currentPhase
                ? { label: options.find(option => option.value === currentPhase)?.label || '', value: currentPhase }
                : null;

              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <TableSelector
                    options={options}
                    value={selectedPhase}
                    isClearable={true}
                    isSearchable={false}
                    onChange={async (selectedValue) => {
                      const newPhase = selectedValue?.value || '';

                      if (newPhase === currentPhase) return;

                      setCurrentPhase(newPhase);
                      setProjects(oldProjects =>
                        oldProjects.map(project =>
                          project.slug === rowData.slug
                            ? { ...project, phase: newPhase }
                            : project
                        )
                      );

                      appState.setAutosavingState(SavingState.SAVING);
                      try {
                        await ServiceProjects.updateProjectPhase(rowData.slug, newPhase);
                        appState.setAutosavingState(SavingState.DONE);
                      } catch (error) {
                        console.error('Failed to update phase:', error);
                        setCurrentPhase(currentPhase);
                        setProjects(oldProjects =>
                          oldProjects.map(project =>
                            project.slug === rowData.slug
                              ? { ...project, phase: currentPhase }
                              : project
                          )
                        );
                        appState.setAutosavingState(SavingState.HIDDEN);
                      }
                    }}
                  />
                </div>
              );
            },
            customSort: (a, b) => {
              const phaseA = a?.phase || '';
              const phaseB = b?.phase || '';

              if (phaseA === '' && phaseB !== '') return 1;
              if (phaseA !== '' && phaseB === '') return -1;
              return phaseA.localeCompare(phaseB);
            },
            cellStyle: { width: '200px' },
            align: 'left'
          };
        case 'Projektnummer':
          return {
            title: COLUMN_NAMES.projectNo,
            field: 'number',
            customSort: (a, b) => {
              const an = a?.number * 1;
              const bn = b?.number * 1;
              if (isNaN(an) && !isNaN(bn)) return 1;
              if (!isNaN(an) && isNaN(bn)) return -1;
              if (!isNaN(an) && !isNaN(bn)) {
                return an < bn ? -1 : (an === bn ? 0 : 1);
              } else {
                const aa = a?.number ?? '';
                const bb = b?.number ?? '';
                return aa.localeCompare(bb, undefined, { numeric: true });
              }
            },
          };
        case 'Projekttyp':
          return {
            title: COLUMN_NAMES.projectType,
            cellStyle: { width: 'unset' },
            width: '100px',
            render: (rowData) => rowData.projectTypeName && t(`projectType.${rowData.projectTypeName.replace(/[\s&/]/g, '')}`, rowData.projectTypeName)
          };
        case 'Kommun':
          return {
            title: COLUMN_NAMES.region,
            field: 'province',
            render: (rowData) => {
              let normalizedKommunName;
              let kommunIcon;
              if (rowData.province) {
                normalizedKommunName = rowData.province.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ', '-');
                kommunIcon = images[`${normalizedKommunName}.png`];
              }
              return (
                <div style={{ display: 'flex', gap: '10px' }}>
                  {rowData.province && <img width={'17px'} height={'20px'} src={kommunIcon} />}
                  <span>{rowData.province || '-'}</span>
                </div>
              )
            },
            cellStyle: { width: 'unset' },
          };
        case 'Upphandlingar': {
          const numberOfAreas = (rowData) => rowData.stepOneAreas + rowData.stepTwoAreas + rowData.stepThreeAreas + rowData.stepFourAreas;
          return {
            title: COLUMN_NAMES.requests,
            customSort: (a, b) => numberOfAreas(a) - numberOfAreas(b),
            render: (rowData) => {
              const totalProjectAreas = numberOfAreas(rowData);
              return <strong style={{ fontSize: '14px' }}>{totalProjectAreas}</strong>
            },
            cellStyle: { width: 'unset' },
            align: 'left'
          }
        }
        case 'Status':
          return {
            title: COLUMN_NAMES.status,
            sorting: false,
            render: (rowData) => {
              const totalProjectAreas = rowData.stepOneAreas + rowData.stepTwoAreas + rowData.stepThreeAreas + rowData.stepFourAreas;
              return totalProjectAreas > 0 && (
                <div className="areaDisplayContainer">
                  {rowData.stepOneAreas > 0 && (
                    <div className="barContainer" style={{ width: `${(rowData.stepOneAreas / totalProjectAreas) * 100}%` }}>
                      <div className="barOne" />
                      <span>{rowData.stepOneAreas}</span>
                    </div>
                  )}
                  {rowData.stepTwoAreas > 0 && (
                    <div className="barContainer" style={{ width: `${(rowData.stepTwoAreas / totalProjectAreas) * 100}%` }}>
                      <div className="barTwo" />
                      <span>{rowData.stepTwoAreas}</span>
                    </div>
                  )}
                  {rowData.stepThreeAreas > 0 && (
                    <div className="barContainer" style={{ width: `${(rowData.stepThreeAreas / totalProjectAreas) * 100}%` }}>
                      <div className="barThree" />
                      <span>{rowData.stepThreeAreas}</span>
                    </div>
                  )}
                  {rowData.stepFourAreas > 0 && (
                    <div className="barContainer" style={{ width: `${(rowData.stepFourAreas / totalProjectAreas) * 100}%` }}>
                      <div className="barFour" />
                      <span>{rowData?.stepFourAreas}</span>
                    </div>
                  )}
                </div>
              )
            },
            cellStyle: { width: 'unset' },
          }
        case 'Estimerad projektkostnad': {
          const estimatedCostSortKey = (rowData) => rowData.estimatedCost ? rowData.estimatedCost.split(/\D/)[0] * 1 : -1;
          return {
            title: COLUMN_NAMES.estCost,
            field: 'estimatedCost',
            customSort: (a, b) => estimatedCostSortKey(a) - estimatedCostSortKey(b),
            render: (rowData) => t('table.row.estCost', '{{estimatedCost}} MSEK', { estimatedCost: rowData.estimatedCost }),
            emptyValue: '-',
            cellStyle: { width: '250px' },
          }
        }
      }
    }), {
      title: '',
      align: 'center',
      render: (rowData) => isWriteAccessRole && (
        <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          {!isLoading && <OptionsMenu style={{ width: '100%', height: '100%', display: 'grid', placeItems: 'center' }} options={[
            {
              label: t('table.row.tools.removeProject', 'Ta bort projekt'),
              action: async () => {
                const isProjectRemoved = await removeProject(rowData._id, rowData.name, rowData.slug);
                if (isProjectRemoved) {
                  setProjects(oldProjects => oldProjects.filter(oldProject => oldProject._id != rowData._id))
                }
              },
              icon: <TrashIcon color="var(--gray-700)" size="16px" />
            },
            {
              label: t('table.row.tools.clearNotifications', 'Markera alla meddelanden som lästa'),
              action: async () => {
                const clearedNotifications = await clearNotifications(rowData._id, rowData.name);
                if (clearedNotifications) {
                  setProjects(oldProjects => oldProjects.map(oldProject =>
                    oldProject._id == rowData._id ? { ...oldProject, notification: 0 } : oldProject
                  ))
                }
              },
              icon: <EmailCheckIcon color='var(--gray-700)' />
            },
            {
              label: t('settings.edit', 'Redigera'),
              action: async () => {
                try {
                  const fullProject = await ServiceProjects.getProject(rowData.slug);
                  const project = Array.isArray(fullProject) ? fullProject[0] : fullProject;
                  const formattedProject = {
                    _id: project._id,
                    name: project.name,
                    province: project.province,
                    phase: project.phase,
                    entreprenad: project.entreprenad,
                    projectType: project.projectTypeLookup,
                    customer: project.customer,
                    estimatedCost: project.estimatedCost,
                    number: project.number,
                    slug: project.slug,
                    responsible: project.responsible,
                    user: project.user,
                  };
                  setProjectToEdit(formattedProject);
                  setShowEditModal(true);
                } catch (error) {
                  console.error('Failed to fetch project details:', error);
                }
              },
              icon: <EditIcon color='var(--gray-700)' style={{ width: 16, height: 16 }} />
            },
            {
              label: rowData.isOpen
                ? t('singleProject.button.endProject', 'Avsluta projektet')
                : t('singleProject.button.restartProject', 'Återuppta projektet'),
              action: async () => {
                try {
                  const newStatus = !rowData.isOpen;
                  await ServiceProjects.updateProjectOpenStatus(rowData.slug, newStatus);
                  setProjects(oldProjects => oldProjects.map(oldProject =>
                    oldProject._id === rowData._id ? { ...oldProject, isOpen: newStatus } : oldProject
                  ));

                  // Show success toast
                  NotificationManager.success(
                    t('notification.success.description.statusUpdated', 'Statusen har blivit uppdaterad.'),
                    t('notification.success.title.statusUpdated', 'Ändring utförd')
                  );
                } catch (error) {
                  console.error('Failed to toggle project status:', error);
                  NotificationManager.error(
                    t('notification.error.description.statusUpdateFailed', 'Det gick inte att uppdatera projektstatus.'),
                    t('notification.error.title.statusUpdateFailed', 'Misslyckat')
                  );
                }
              },
              icon: <PowerIcon color="var(--gray-700)" style={{ width: 16, height: 16 }} />
            },
          ]} />}
        </div>
      ),
      cellStyle: { width: 'unset' },
      width: '30px'
    }];
  }

  const legends = useMemo(() => [
    {
      color: 'var(--darkBlue)',
      label: t('table.legends.request', 'Förfrågan'),
    },
    {
      color: 'var(--sunglowYellow)',
      label: t('table.legends.evaluation', 'Utvärdering'),
    },
    {
      color: 'var(--crayolaGreen)',
      label: t('table.legends.negotiation', 'Förhandling'),
    },
    {
      color: 'var(--gray-500)',
      label: t('table.legends.agreement', 'Avtal'),
    },
  ], [t]);

  const getCurrentPageOfProjects = projects => {
    return projects
      .slice(currentPage * pageLimit - pageLimit, currentPage * pageLimit)
      .map(project => {
        let foundCost = appEnum
          .getProjectCostDataSource()
          .find(id => id.key == project.estimatedCost);
        return { ...project, estimatedCost: foundCost?.value };
      });
  };

  const onSubmitFilter = useCallback((appliedFilters) => {
    setFiltersData(appliedFilters);
  }, []);

  const onCancelFilter = useCallback(() => {
    toggleFilter(!showFilter);
    let resetFilter = { kommun: [], projectType: [], phase: [], users: [] };
    setFiltersData(resetFilter);
  }, [showFilter, filtersData]);

  const filterCheckboxes = useMemo(() => [
    {
      label: COLUMN_NAMES.region,
      name: 'kommun',
      value: filtersData.kommun || (cities[0]?.value ?? ''),
      subChecks: cities.map(city => ({
        label: city.label,
        name: 'kommun',
        value: city.value,
      }))
    },
    {
      label: COLUMN_NAMES.projectType,
      name: 'projectType',
      value: filtersData.projectType,
      subChecks: projectTypes.map(pt => ({
        label: pt.label && t(`projectType.${pt.label.replace(/[\s&/]/g, '')}`, pt.label),
        name: 'projectType',
        value: pt.label,
      }))
    },
    {
      label: COLUMN_NAMES.phase,
      name: 'phase',
      value: filtersData.phase || '',
      subChecks: [
        { label: t('projectPhase.AnbudKalkyl', 'Anbud/Kalkyl'), name: 'phase', value: 'Anbud/Kalkyl' },
        { label: t('projectPhase.InköpProduktion', 'Inköp/Produktion'), name: 'phase', value: 'Inköp/Produktion' },
        { label: t('projectPhase.empty', 'Ej angivet'), name: 'phase', value: '' }
      ],
    },
    {
      label: COLUMN_NAMES.users,
      name: 'users',
      value: filtersData.users || [],
      subChecks: (() => {
        const currentUser = appState.getLoggedInUserDetail();
        const userOptions = users
          .filter(user => user.value) // Filter out users without valid IDs
          .map(user => ({
            label: user.label,
            name: 'users',
            value: user.value,
          }));

        const currentUserExists = userOptions.find(user => user.value === currentUser?.id);
        if (!currentUserExists && currentUser) {
          userOptions.unshift({
            label: currentUser.name,
            name: 'users',
            value: currentUser.id,
          });
        }

        return userOptions;
      })()
    },

  ], [cities, projectTypes, filtersData, t, users]);



  const tableColumns = isLoading ? [] : getColumns().filter((x) => x);
  const numberOfPages = Math.ceil(selectedProjects.length / pageLimit);

  return (
    <AppLayout title={t('pageTitle', 'Projekt')}>
      <div className="pageProjectStartContainer">
        <div className="tab-container">
          <Tabs
            tabs={[t('tabs.ongoing', 'Pågående Projekt'), t('tabs.expired', 'Avslutade Projekt')]}
            selected={selectedProjectTab}
            onChange={setSelectedProjectTab}
          />
          {isWriteAccessRole && (
            <div className="tab-actions">
              <BtButton onClick={async () => {
                const clearedNotifications = await clearAllNotifications();
                if (clearedNotifications) {
                  setProjects(oldProjects => oldProjects.map(oldProject => ({ ...oldProject, notification: 0 })));
                }
              }} color="white">{t('button.clearNotifications', 'Rensa aviseringar')}</BtButton>
              <BtButton onClick={addProject}>{t('button.newProject', 'Nytt projekt')}</BtButton>
            </div>
          )}
        </div>
        <SearchBarWithActions value={searchValue} onChange={setSearchValue}>
          <FiltersDropdown
            onSubmitFilter={onSubmitFilter}
            onResetFilter={onCancelFilter}
            checkboxes={filterCheckboxes}
            showFilter={showFilter}
            toggleFilter={toggleFilter}
            filtersData={filtersData}
            multiple
          />
          <CustomizationMenu columns={columns} setColumns={updateColumns} />
        </SearchBarWithActions>

        <Legends legendsArray={legends} />

        <DataTable
          tableRef={tableRef}
          isLoading={isLoading}
          columns={tableColumns}
          data={getCurrentPageOfProjects(selectedProjects)}
          onRowClick={(e, rowData) => {
            const orgSlug = appState._getCurrentOrgUrl();
            history.push(`${orgSlug}/projects/${rowData.slug}`)
          }}
          isScrollable
          style={{ maxHeight: "calc(100vh - 360px)" }}
        />

        {numberOfPages > 1 && (
          <PaginationWithGoTo
            count={numberOfPages}
            onChange={(_, value) => setCurrentPage(value)}
            page={currentPage}
            t={tPagination}
          />
        )}

        <Modal
          title={t('settings.edit', 'Redigera')}
          show={showEditModal}
          buttonInfo={{
            label: t('createProject.button.edit', 'Spara'),
            action: () => {
              if (appCreateProjectRef.current) {
                appCreateProjectRef.current.btnCreateProjectClickCallback();
              }
            },
            loaderShow: false
          }}
          setShow={(value) => {
            setShowEditModal(value);
            if (!value) setProjectToEdit(null);
          }}
        >
          <AppCreateProject
            ref={appCreateProjectRef}
            currentProject={projectToEdit}
            users={users}
            onProjectUpdateCreated={async (sender, updatedProject) => {
              await refreshProjectList();
              setShowEditModal(false);
              setProjectToEdit(null);
            }}
          />
        </Modal>
      </div>
    </AppLayout>
  );
}
